export function pickRecordProperty<T, U extends keyof T>(record: Record<string, T>, recordProperty: U): Record<string, T[U]> {
	const newRecord: Record<string, T[U]> = {};

	Object.keys(record).forEach((recordKey) => {
		newRecord[recordKey] = record[recordKey][recordProperty];
	});

	return newRecord;
}

export function removeEmptyPropertiesFromNestedObjects(obj: object) {
	const newObj = {};
	Object.keys(obj).forEach((key) => {
		if (obj[key] === Object(obj[key])) {
			newObj[key] = removeEmptyPropertiesFromNestedObjects(obj[key]);
		} else if (obj[key] !== undefined && obj[key] !== null) {
			newObj[key] = obj[key];
		}
	});
	return newObj;
}

function isObject(item: any): item is Record<string, any> {
	return item && typeof item === 'object' && !Array.isArray(item);
}

export function deepMerge<T extends Record<string, any>, U extends Record<string, any>>(obj1: T, obj2: U): T & U {
	for (const key in obj2) {
		// eslint-disable-next-line no-prototype-builtins
		if (obj2.hasOwnProperty(key)) {
			if (isObject(obj2[key]) && isObject(obj1[key])) {
				obj1[key] = deepMerge(obj1[key], obj2[key]);
			} else {
				(obj1 as Record<string, any>)[key] = obj2[key];
			}
		}
	}
	return obj1 as T & U;
}
